var _mask, _rect, _mask2, _rect2, _mask3, _rect3, _mask4, _rect4, _mask5, _rect5, _mask6, _rect6, _mask7, _rect7, _mask8, _rect8, _mask9, _rect9, _mask10, _rect10, _mask11, _rect11, _mask12, _rect12, _mask13, _rect13, _mask14, _rect14, _mask15, _rect15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_3373_1284",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 64,
    width: 8,
    height: 8,
    rx: 0.5
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 64,
    width: 8,
    height: 8,
    rx: 0.5,
    stroke: "#39C5CA",
    strokeWidth: 2,
    mask: "url(#path-1-inside-1_3373_1284)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-2_3373_1284",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 64,
    width: 8,
    height: 8,
    rx: 0.5
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 64,
    width: 8,
    height: 8,
    rx: 0.5,
    stroke: "#39C5CA",
    strokeWidth: 2,
    mask: "url(#path-2-inside-2_3373_1284)"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-3_3373_1284",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 52,
    width: 8,
    height: 8,
    rx: 0.5
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 52,
    width: 8,
    height: 8,
    rx: 0.5,
    stroke: "#39C5CA",
    strokeWidth: 2,
    mask: "url(#path-3-inside-3_3373_1284)"
  })), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-4_3373_1284",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 40,
    width: 8,
    height: 8,
    rx: 0.5
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 40,
    width: 8,
    height: 8,
    rx: 0.5,
    stroke: "#39C5CA",
    strokeWidth: 2,
    mask: "url(#path-4-inside-4_3373_1284)"
  })), _mask5 || (_mask5 = /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-5_3373_1284",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 28,
    width: 20,
    height: 8,
    rx: 0.5
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 28,
    width: 20,
    height: 8,
    rx: 0.5,
    stroke: "#39C5CA",
    strokeWidth: 2,
    mask: "url(#path-5-inside-5_3373_1284)"
  })), _mask6 || (_mask6 = /*#__PURE__*/React.createElement("mask", {
    id: "path-6-inside-6_3373_1284",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 64,
    width: 20,
    height: 8,
    rx: 0.5
  }))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 64,
    width: 20,
    height: 8,
    rx: 0.5,
    stroke: "#39C5CA",
    strokeWidth: 2,
    mask: "url(#path-6-inside-6_3373_1284)"
  })), _mask7 || (_mask7 = /*#__PURE__*/React.createElement("mask", {
    id: "path-7-inside-7_3373_1284",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 40,
    width: 20,
    height: 20,
    rx: 0.5
  }))), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 40,
    width: 20,
    height: 20,
    rx: 0.5,
    stroke: "#39C5CA",
    strokeWidth: 2,
    mask: "url(#path-7-inside-7_3373_1284)"
  })), _mask8 || (_mask8 = /*#__PURE__*/React.createElement("mask", {
    id: "path-8-inside-8_3373_1284",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 40,
    width: 24,
    height: 32,
    rx: 0.5
  }))), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    y: 40,
    width: 24,
    height: 32,
    rx: 0.5,
    stroke: "#39C5CA",
    strokeWidth: 2,
    mask: "url(#path-8-inside-8_3373_1284)"
  })), _mask9 || (_mask9 = /*#__PURE__*/React.createElement("mask", {
    id: "path-9-inside-9_3373_1284",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 36,
    rx: 0.5
  }))), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 36,
    rx: 0.5,
    stroke: "#39C5CA",
    strokeWidth: 2,
    mask: "url(#path-9-inside-9_3373_1284)"
  })), _mask10 || (_mask10 = /*#__PURE__*/React.createElement("mask", {
    id: "path-10-inside-10_3373_1284",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28,
    width: 20,
    height: 24,
    rx: 0.5
  }))), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    width: 20,
    height: 24,
    rx: 0.5,
    stroke: "#39C5CA",
    strokeWidth: 2,
    mask: "url(#path-10-inside-10_3373_1284)"
  })), _mask11 || (_mask11 = /*#__PURE__*/React.createElement("mask", {
    id: "path-11-inside-11_3373_1284",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 28,
    width: 20,
    height: 8,
    rx: 0.5
  }))), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 28,
    width: 20,
    height: 8,
    rx: 0.5,
    stroke: "#39C5CA",
    strokeWidth: 2,
    mask: "url(#path-11-inside-11_3373_1284)"
  })), _mask12 || (_mask12 = /*#__PURE__*/React.createElement("mask", {
    id: "path-12-inside-12_3373_1284",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 16,
    width: 20,
    height: 8,
    rx: 0.5
  }))), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 16,
    width: 20,
    height: 8,
    rx: 0.5,
    stroke: "#39C5CA",
    strokeWidth: 2,
    mask: "url(#path-12-inside-12_3373_1284)"
  })), _mask13 || (_mask13 = /*#__PURE__*/React.createElement("mask", {
    id: "path-13-inside-13_3373_1284",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 52,
    width: 20,
    height: 12,
    rx: 0.5
  }))), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    width: 20,
    height: 12,
    rx: 0.5,
    stroke: "#39C5CA",
    strokeWidth: 2,
    mask: "url(#path-13-inside-13_3373_1284)"
  })), _mask14 || (_mask14 = /*#__PURE__*/React.createElement("mask", {
    id: "path-14-inside-14_3373_1284",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 40,
    width: 8,
    height: 8,
    rx: 0.5
  }))), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 40,
    width: 8,
    height: 8,
    rx: 0.5,
    stroke: "#39C5CA",
    strokeWidth: 2,
    mask: "url(#path-14-inside-14_3373_1284)"
  })), _mask15 || (_mask15 = /*#__PURE__*/React.createElement("mask", {
    id: "path-15-inside-15_3373_1284",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 52,
    width: 8,
    height: 8,
    rx: 0.5
  }))), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 52,
    width: 8,
    height: 8,
    rx: 0.5,
    stroke: "#39C5CA",
    strokeWidth: 2,
    mask: "url(#path-15-inside-15_3373_1284)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon5);
export default __webpack_public_path__ + "static/media/icon5.a16218416481109a558cbfa27df55254.svg";
export { ForwardRef as ReactComponent };